<template>
    <div class="timeline-mouth-panel">
        <h3 class="timeline-mouth-panel__title">{{title}}</h3>
        <div class="timeline-mouth-panel__content">
            <ul class="timeline-mouth-panel__blog-list">
                <template v-for="item in child">
                    <li class="timeline-mouth-panel__blog-item" :key="item.id">
                        <router-link class="timeline-mouth-panel__blog-link"
                                     :to="{name:'blog',params:{id:item.id}}"
                        >
                            <span class="timeline-mouth-panel__blog-date">{{formatDate(item.publishDate)}}</span>
                            <span class="timeline-mouth-panel__blog-title">{{item.title}}</span>
                        </router-link>
                    </li>
                </template>

            </ul>
        </div>
    </div>
</template>

<script>
    import {formatDate} from '@utils'

    export default {
        name: "TimelineMouth",
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        computed: {
            title() {
                const {data} = this
                const {title} = data
                let month = parseInt(title) || 1
                return `${month}月`
            },
            child() {
                const {data} = this
                return data.child || []
            }
        },
        methods: {
            formatDate(date) {
                if (date) {
                    return formatDate(new Date(date), 'MM-dd')
                }
                return '无'
            },
        },
        components: {}
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .timeline-mouth-panel {
        padding: $paddingBase $paddingMD;
        margin-bottom: $paddingBase;

        &__title {
            font-size: $fontSize;
            font-weight: $fontWeightBold;
            color: $textColor;
            color: var(--textColor);
        }

        &__blog-list {
            padding-left: $paddingSP;
        }

        &__blog-item {
            position: relative;
            margin-top: $paddingBase;
            cursor: pointer;

            &:hover {
                &:before {
                    background-color: $primaryColor;
                    background-color: var(--primaryColor);
                }

                .timeline-mouth-panel__blog-date,
                .timeline-mouth-panel__blog-title {
                    color: $primaryColor;
                }
            }


            &:before {
                content: ' ';
                position: absolute;
                left: -$paddingMD;
                width: 6px;
                height: 6px;
                top: 10px;
                border-radius: 50%;
                background-color: $secondaryTextColor;
                background-color: var(--secondaryTextColor);
                @include transition-colors;
            }
        }

        &__blog-date {
            display: inline-block;
            margin-right: $paddingMD;
            color: $secondaryTextColor;
            color: var(--secondaryTextColor);
            font-size: $fontSizeCommon;
            line-height: $fontSize;
            font-weight: $fontWeightTin;
        }

        &__blog-title {
            color: $textColor;
            color: var(--textColor);
            font-weight: $fontWeightBold;
            font-size: $fontSize;
        }

        &__blog-link {
            display: inline-block;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &__blog-date,
        &__blog-title {
            @include transition-colors;
        }


    }
</style>